/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tx-modal-component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from 'angular2-materialize/dist/materialize-directive';
import * as i3 from '../../../../../app/shared/component/tx-modal/tx-modal-component';
const styles_TxModalComponent:any[] = [i0.styles];
export const RenderType_TxModalComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TxModalComponent,data:{}});
export function View_TxModalComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),25,'div',[['id',
      'txModal'],['materialize','modal']],[[8,'className',0]],(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(1,5128192,(null as any),0,i2.MaterializeDirective,
      [i1.ElementRef],{materializeParams:[0,'materializeParams'],materializeActions:[1,
          'materializeActions'],materialize:[2,'materialize']},(null as any)),i1.ɵpod(2,
      {dismissible:0}),i1.ɵpad(3,1),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵeld(5,0,(null as any),(null as any),10,'div',([] as any[]),[[8,'className',
          0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n    '])),(_l()(),i1.ɵeld(7,0,(null as any),(null as any),7,
      'div',[['class','row']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(9,
      0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(10,(null as any),
      ['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(12,
      0,(null as any),(null as any),1,'h4',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(13,(null as any),
      ['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(17,0,
      (null as any),(null as any),7,'div',[['class','modal-footer']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n    '])),(_l()(),i1.ɵeld(19,0,(null as any),(null as any),
      1,'a',[['class','modal-action modal-close waves-effect btn-flat ']],(null as any),
      [[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.TxModalComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.close()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(20,(null as any),['',''])),(_l()(),
      i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(22,0,(null as any),(null as any),
      1,'a',[['class','modal-action modal-close waves-effect btn-flat tx-text-accent']],
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.TxModalComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.submit()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(23,(null as any),['',''])),(_l()(),
      i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.TxModalComponent = _v.component;
    const currVal_1:any = _ck(_v,3,0,_ck(_v,2,0,false));
    const currVal_2:any = _co.modalActions;
    const currVal_3:any = 'modal';
    _ck(_v,1,0,currVal_1,currVal_2,currVal_3);
  },(_ck,_v) => {
    var _co:i3.TxModalComponent = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.modalClass,' modal modal-fixed-footer');
    _ck(_v,0,0,currVal_0);
    const currVal_4:any = i1.ɵinlineInterpolate(1,'',_co.contentClass,' modal-content');
    _ck(_v,5,0,currVal_4);
    const currVal_5:any = _co.title;
    _ck(_v,10,0,currVal_5);
    const currVal_6:any = _co.message;
    _ck(_v,13,0,currVal_6);
    const currVal_7:any = _co.refuseButton;
    _ck(_v,20,0,currVal_7);
    const currVal_8:any = _co.submitButton;
    _ck(_v,23,0,currVal_8);
  });
}
export function View_TxModalComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'tx-modal',([] as any[]),
      (null as any),(null as any),(null as any),View_TxModalComponent_0,RenderType_TxModalComponent)),
      i1.ɵdid(1,114688,(null as any),0,i3.TxModalComponent,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TxModalComponentNgFactory:i1.ComponentFactory<i3.TxModalComponent> = i1.ɵccf('tx-modal',
    i3.TxModalComponent,View_TxModalComponent_Host_0,{title:'title',message:'message',
        modalActions:'modalActions',model:'model',refuseButton:'refuseButton',submitButton:'submitButton',
        modalClass:'modalClass',contentClass:'contentClass'},{txOnSubmit:'txOnSubmit'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-modal/tx-modal-component.ngfactory.ts